export enum ShapeType {
  Circle,
  Triangle,
  Square,
}
